/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function JournalVoucher6Info({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { rows = [], debitAccountLabels = [], totals = {} } = values;

  const handleChangeField = (path, val) => setFieldValue(path, val);

  const calculateRowSums = (row) => {
    const totalCredit334 = (row.debitValues334 || []).reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
    const totalCredit338 = (row.debitValues338 || []).reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
    return { ...row, totalCredit334, totalCredit338 };
  };

  const updateCalculations = () => {
    const newRows = rows.map(calculateRowSums);
    
    const newTotals = {
      debitValues334: Array(10).fill(0),
      totalCredit334: 0,
      debitValues338: Array(10).fill(0),
      totalCredit338: 0,
    };

    newRows.forEach(r => {
      (r.debitValues334 || []).forEach((v, i) => { 
        if (i < 10) newTotals.debitValues334[i] += (parseFloat(v) || 0); 
      });
      newTotals.totalCredit334 += r.totalCredit334 || 0;

      (r.debitValues338 || []).forEach((v, i) => { 
        if (i < 10) newTotals.debitValues338[i] += (parseFloat(v) || 0); 
      });
      newTotals.totalCredit338 += r.totalCredit338 || 0;
    });

    if (JSON.stringify(newRows) !== JSON.stringify(rows)) setFieldValue("rows", newRows);
    if (JSON.stringify(newTotals) !== JSON.stringify(totals)) setFieldValue("totals", newTotals);
  };

  useEffect(() => {
    updateCalculations();
  }, [JSON.stringify(rows.map(r => ({
    d334: r.debitValues334,
    d338: r.debitValues338
  })))]);

  const addRow = () => setFieldValue("rows", [...rows, {
    index: rows.length + 1,
    voucherNumber: "",
    voucherDate: "",
    description: "",
    debitValues334: Array(10).fill(0),
    totalCredit334: 0,
    debitValues338: Array(10).fill(0),
    totalCredit338: 0,
  }]);

  const removeRow = (idx) => {
    if (rows.length <= 1) return;
    setFieldValue("rows", rows.filter((_, i) => i !== idx));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.4" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "30px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" },
  };

  return (
    <SoftBox style={s.container}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <div style={{ width: "40%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>Mẫu số S04a6-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>NHẬT KÝ CHỨNG TỪ SỐ 6</h2>
        <div style={{ fontSize: "14px", fontStyle: "italic", marginTop: "5px" }}>
            Ghi Có TK 334 - Phải trả NLĐ, TK 338 - Phải trả, phải nộp khác
        </div>
        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          Tháng <input disabled={containView} style={{ ...s.inputDotted, width: "50px", textAlign: "center" }} value={values.month} onChange={(e) => handleChangeField("month", e.target.value)} />
          {" "}năm <input disabled={containView} style={{ ...s.inputDotted, width: "70px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>

      <div style={{ overflowX: "auto", border: "1px solid #000" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1400px", fontSize: "12px" }}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "40px" }} rowSpan={2}>STT</th>
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={{ ...s.th, width: "150px" }} rowSpan={2}>Diễn giải</th>
              <th style={{ ...s.th, width: "80px" }} rowSpan={2}>Ghi Có TK</th>
              <th style={s.th} colSpan={10}>Ghi Nợ các Tài khoản đối ứng</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Tổng cộng ghi Có</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={2}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "80px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "80px" }}>Ngày</th>
              {[...Array(10)].map((_, i) => (
                <th key={i} style={{ ...s.th, width: "80px" }}>
                    <input disabled={containView} style={s.inputTableCenter} placeholder="..." value={debitAccountLabels[i]} onChange={(e) => {
                        const newLabels = [...debitAccountLabels];
                        newLabels[i] = e.target.value;
                        setFieldValue("debitAccountLabels", newLabels);
                    }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <React.Fragment key={idx}>
                <tr>
                  <td style={{ ...s.td, textAlign: "center" }} rowSpan={2}>
                    <input disabled={containView} style={s.inputTableCenter} value={row.index} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].index = e.target.value;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                  <td style={{ ...s.td, textAlign: "center" }} rowSpan={2}>
                    <input disabled={containView} style={s.inputTableCenter} value={row.voucherNumber} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].voucherNumber = e.target.value;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                  <td style={{ ...s.td, textAlign: "center" }} rowSpan={2}>
                    <input disabled={containView} style={s.inputTableCenter} value={row.voucherDate} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].voucherDate = e.target.value;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                  <td style={{ ...s.td, padding: "0 4px" }} rowSpan={2}>
                    <input disabled={containView} style={s.inputTable} value={row.description} onChange={(e) => {
                      const newRows = [...rows];
                      newRows[idx].description = e.target.value;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                  <td style={{ ...s.td, textAlign: "center", backgroundColor: "#f9f9f9", fontWeight: "bold" }}>334</td>
                  {[...Array(10)].map((_, i) => (
                    <td key={i} style={s.td}>
                      <input disabled={containView} type="number" style={s.inputTableRight} value={row.debitValues334[i]} onChange={(e) => {
                        const newRows = [...rows];
                        newRows[idx].debitValues334[i] = e.target.value;
                        setFieldValue("rows", newRows);
                      }} />
                    </td>
                  ))}
                  <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee", fontWeight: "bold" }}>{fmt(row.totalCredit334)}</td>
                  {!containView && (
                    <td style={{ ...s.td, textAlign: "center" }} rowSpan={2}>
                      <button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>-</button>
                    </td>
                  )}
                </tr>
                <tr>
                  <td style={{ ...s.td, textAlign: "center", backgroundColor: "#f9f9f9", fontWeight: "bold" }}>338</td>
                  {[...Array(10)].map((_, i) => (
                    <td key={i} style={s.td}>
                      <input disabled={containView} type="number" style={s.inputTableRight} value={row.debitValues338[i]} onChange={(e) => {
                        const newRows = [...rows];
                        newRows[idx].debitValues338[i] = e.target.value;
                        setFieldValue("rows", newRows);
                      }} />
                    </td>
                  ))}
                  <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#eee", fontWeight: "bold" }}>{fmt(row.totalCredit338)}</td>
                </tr>
              </React.Fragment>
            ))}
            
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td} colSpan={4} align="center">Cộng</td>
              <td style={{ ...s.td, textAlign: "center" }}>334</td>
              {totals.debitValues334?.map((v, i) => (
                <td key={i} style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.totalCredit334)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={s.td} colSpan={4} align="center"></td>
              <td style={{ ...s.td, textAlign: "center" }}>338</td>
              {totals.debitValues338?.map((v, i) => (
                <td key={i} style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(totals.totalCredit338)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
      </div>

      {!containView && (
        <SoftBox textAlign="center" mt={2}>
          <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm dòng</SoftButton>
        </SoftBox>
      )}

      <div style={{ marginTop: "15px" }}>
          Đã ghi Sổ Cái ngày <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerDay} onChange={(e) => handleChangeField("recordedToLedgerDay", e.target.value)} />
          {" "} tháng <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerMonth} onChange={(e) => handleChangeField("recordedToLedgerMonth", e.target.value)} />
          {" "} năm <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.recordedToLedgerYear} onChange={(e) => handleChangeField("recordedToLedgerYear", e.target.value)} />
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <div style={{ marginTop: "30px" }}>
            <input disabled={containView} style={{ ...s.inputDotted, textAlign: "center", width: "100%" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} placeholder="..." />
          </div>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <div style={{ marginTop: "30px" }}>
            <input disabled={containView} style={{ ...s.inputDotted, textAlign: "center", width: "100%" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} placeholder="..." />
          </div>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} />
            {" "} tháng <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} />
            {" "} năm <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên, đóng dấu)</div>
          <div style={{ marginTop: "30px" }}>
            <input disabled={containView} style={{ ...s.inputDotted, textAlign: "center", width: "100%" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} placeholder="..." />
          </div>
        </div>
      </div>
    </SoftBox>
  );
}

export default JournalVoucher6Info;
